// Brief 85 §2 — MediatorModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "me":`
// clause it left —
//   sha256 7993241a25553c31bf0e92fed97c244036a5cbfe6cfef18a14a30e60cf6d4b5f
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import AddressFields from "./AddressFields";
import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TaxList, TFn } from "../../lib/taxonomyTypes";
import type { FieldSelectOption } from "../FieldSelect";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { country?: string | null; id?: string | null };

type Props = {
  BarAssoc: Vocab["BarAssoc"];
  F: Vocab["F"];
  NA: Vocab["NA"];
  T: Vocab["T"];
  TitSel: Vocab["TitSel"];
  _fl: Vocab["_fl"];
  _mt: Vocab["_mt"];
  cm: () => void;
  countriesList: readonly FieldSelectOption[];
  countryEntries: TaxList;
  form: ModalForm;
  mediators: readonly unknown[];
  saveEntity: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown, ext?: Record<string, unknown>) => void;
  setMediators: (v: readonly unknown[]) => void;
  t: TFn;
  updateField: (k: string, v: string) => void;
};

export default function MediatorModal({
  BarAssoc,
  F,
  NA,
  T,
  TitSel,
  _fl,
  _mt,
  cm,
  countriesList,
  countryEntries,
  form,
  mediators,
  saveEntity,
  setMediators,
  t,
  updateField,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Mediator") : _mt("New Mediator")}
            onClose={cm}
            onSave={() =>
              saveEntity(SK.me, mediators, setMediators, form, { country: form.country || null })
            }
          >
              <>
                <div className="field-row">
                  {TitSel}
                  {F("First Name *", "firstName", "", 1)}
                </div>
                <div className="field-row">
                  {F("Last Name *", "lastName")}
                  {F("Specialty", "specialty")}
                </div>
                {NA({
                  pool: mediators,
                  typeLabel: t("type.mediator", { fallback: "mediator" }),
                })}
                {F("Practice", "firm")}
                <div className="field-row">
                  {F("Email", "email")}
                  {F("Phone", "phone")}
                </div>
                {BarAssoc}
                <AddressFields
                  F={F}
                  _fl={_fl}
                  countriesList={countriesList}
                  countryEntries={countryEntries}
                  form={form}
                  t={t}
                  updateField={updateField}
                />
                {T("Notes", "notes")}
              </>
          </ModalLayout>
  );
}
